class BsoCartCondition extends HTMLElement {
  constructor() {
    super();

    this.bsoCart = this.querySelector('.bso-cart');
    this.bsoMessage = this.querySelector('.bso-cart-message');
    this.checkoutButton = this.querySelector('#checkout');
    this.dynamicCheckoutButton = document.querySelector('.cart__dynamic-checkout-buttons');

    if (!this.bsoCart || !this.bsoMessage || !this.checkoutButton) {
      return;
    }
    
    this.totalOrderValue = parseFloat(this.bsoCart.getAttribute('data-total-order'));
    this.minimumTotalOrder = parseFloat(this.bsoCart.getAttribute('data-minimum-total-order'));

    // Initial check
    this.checkCondition(this.totalOrderValue, this.minimumTotalOrder);
    // Subscribe to cart updates
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      this.handleCartUpdate();
    });
  }

  async fetchCartData() {
    try {
      const response = await fetch('/cart.js');
      const cartData = await response.json();
      return cartData;
    } catch (error) {
      console.error('Error fetching cart data:', error);
    }
  }
  
  async handleCartUpdate() {
    const cartData = await this.fetchCartData();
    if (cartData) {
      this.updateCartConditions(cartData);
    }
  }  

  async updateCartConditions(cartData) {
    this.totalOrderValue = cartData.total_price;
    this.checkCondition(this.totalOrderValue, this.minimumTotalOrder);
  }

  checkCondition(totalOrderValue, minimumTotalOrder) {
    if (totalOrderValue <= minimumTotalOrder) {
      this.bsoMessage.style.display = 'block';
      this.checkoutButton.setAttribute('disabled', 'disabled');
      if (this.dynamicCheckoutButton) {
        this.dynamicCheckoutButton.classList.add('disabled');
      }
    } else {
      this.bsoMessage.style.display = 'none';
      this.checkoutButton.removeAttribute('disabled');
      if (this.dynamicCheckoutButton) {
        this.dynamicCheckoutButton.classList.remove('disabled');
      }
    }
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }
}
customElements.define('bso-cart-condition', BsoCartCondition);